import * as Type from './types'

export const closeDrawer = { type: Type.CLOSE_DRAWER }

export const openDrawer = { type: Type.OPEN_DRAWER }
